import { render, staticRenderFns } from "./2_howto.vue?vue&type=template&id=46bca777&scoped=true&"
import script from "./2_howto.vue?vue&type=script&lang=js&"
export * from "./2_howto.vue?vue&type=script&lang=js&"
import style0 from "./2_howto.vue?vue&type=style&index=0&id=46bca777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bca777",
  null
  
)

export default component.exports